<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="accent"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="accent">
            <v-card flat color="accent">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="personalform">
                            <v-list flat color="accent" class="py-0">
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Task Title</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Task Title" rules="required">
                                            <v-text-field
                                            v-model="form.title"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Category" rules="required">
                                            <v-autocomplete
                                                :items="systems"
                                                :error-messages="errors"
                                                v-model="form.system_id"
                                                color="white"
                                                item-text="title"
                                                item-value="id"
                                                placeholder="Category"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Details of the Task</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Details of the Task" rules="required">
                                            <vue-editor v-model="form.details" :error-messages="errors" required/>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Resolution</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider name="Resolution">
                                            <vue-editor v-model="form.resolution"/>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-row
                                    no-gutters
                                    class="grid-items"
                                    >
                                    <v-col
                                        md="6"
                                        cols="12"
                                    >
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                                    <v-select
                                                        :items="statuses"
                                                        :error-messages="errors"
                                                        v-model="form.status_id"
                                                        color="white"
                                                        item-text="title"
                                                        item-value="id"
                                                        placeholder="Status"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                        ></v-select>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-col>
                                    <v-col
                                        md="6"
                                        cols="12"
                                    >
                                        <v-list-item class="form-row">
                                            <v-list-item-content class="label">
                                                <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <ValidationProvider v-slot="{ errors }" name="Assignee" rules="required">
                                                    <v-autocomplete
                                                        multiple
                                                        :items="users"
                                                        :error-messages="errors"
                                                        v-model="form.assignee"
                                                        color="white"
                                                        item-text="name"
                                                        item-value="id"
                                                        placeholder="Assignee"
                                                        required
                                                        solo
                                                        flat
                                                        dark
                                                    ></v-autocomplete>
                                                </ValidationProvider>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
            </v-card>
            <v-card flat tile color="#5e5e5e">
                <v-card-text style="padding-bottom: 80px;">
                    <file-pond
                        name="filepond"
                        ref="filepond"
                        label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                        v-bind:allow-multiple="true"
                        :server="{
                            url: 'https://tasks.bigcitymarketing.co/api/uploads/task?temp_id='+form.unique_id,
                            process: {
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                }
                            },
                            revert: {
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                },
                            }
                        }"
                        v-bind:files="files"
                        v-on:init="handleFilePondInit"
                        v-on:processfile="handleFilePondProcessfile"
                        v-on:processfilerevert="handleFilePondRevertfile"/>
                </v-card-text>
            </v-card>
            <v-card flat color="accent">
                <v-card-actions class="fixed-actions">
                    <v-btn large min-width="50%" color="primary"  @click="submit" :loading="loading" tile depressed>Create</v-btn>
                    <v-btn large min-width="50%" color="white"  to="/tasks" text tile depressed>Cancel</v-btn>
                </v-card-actions> 
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import TokenService from '../../services/storage.service'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

extend('email', {
    ...email,
    message: 'Please enter a valid email address',
})


export default {
    data () {
        return {
            form: {
                system_id: '',
                title: '',
                details: '',
                resolution: '',
                status_id: 1,
                images: [],
                comments: [],
                unique_id: '',
                assignee: [],
            },
            pageTitle: '',
            loading: false,
            yesno: [
                { label: 'Yes', value: 1},
                { label: 'No', value: 0}
            ],
            voptions: {
                toolbar: true,
                url: 'data-source'
            },
            requiredValue: true,
            files: [],
            uploadedFiles: [],
            tab: null,

            token: '',
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.token = TokenService.getToken()
        this.form.unique_id = Math.round(+new Date()/1000)
    },
    computed: {
        ...mapGetters({
            systems: 'data/systems',
            statuses: 'data/task_status',
            users: 'data/users',
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            addTask: 'data/addTask'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.addTask(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ name: 'Task Listing' })
                }).catch((error) => {
                    if(error.response.status == 400){
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        handleFilePondProcessfile: function () {
            this.getTask();
            this.$nextTick()
        },
        handleFilePondRevertfile: function () {
            this.getTask();
            this.$nextTick()
        },
    }
}
</script>

<style scoped>
.fixed-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100; /* make sure it's above other elements */
  background: inherit; /* or set a background color if needed */
  padding: 10px; /* adjust as needed */
}

/* Optional: Add bottom padding to the container that holds your form content */
.scroll-y {
  padding-bottom: 70px; /* adjust to match the height of your fixed actions */
}
</style>

<style lang="sass">
.v-list-item
    @media (min-width: 992px)
        .v-list-item__content.label + .v-list-item__action
            width: 85%

.grid-items
    @media (min-width: 992px)
        .v-list-item__content.label + .v-list-item__action
            width: 77%
</style>
